"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _skeletonLoadingModule = _interopRequireDefault(require("./skeleton-loading.module.css"));
var SkeletonLoading = function SkeletonLoading(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_skeletonLoadingModule.default.skeleton, className)
  }, children);
};
var _default = SkeletonLoading;
exports.default = _default;